(function ($) {
  var prevIndex = 0;
  var currentColour = "";

  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".size-guide").length &&
      $(event.target).closest(".size-guide-section").length
    ) {
      closeSize();
    }
  });

  $(document).ready(function () {
    currentColour = $(".selected-colour").html();

    // if (!$('.size-guide').hasClass('disabled')) {
    //     $('.size-guide-label').show();
    // }

    $(".size-wrap label").click(function (evt) {
      if (isMobile()) return;

      var top = $(window).scrollTop();
      setTimeout(function () {
        $(window).scrollTop(top);
      }, 10);
    });

    $(".product-form__input.color .swatch").mouseover(function () {
      $(".selected-colour").html($(this).data("color-name"));
    });

    $(".product-form__input.color .swatch").mouseleave(function () {
      $(".selected-colour").html(currentColour);
    });

    $(".product-form__input.color .swatch").click(function () {
      var color = $(this).data("color");
      var name = $(this).data("color-name");
      $(".selected-colour").html(name);

      if (currentColour != name && !isMobile()) {
        var body = $("html, body");
        body.stop().animate({ scrollTop: 0 }, 500, "swing");
      }

      currentColour = name;

      changeImages(color);
    });

    $(document).on("click", ".size-guide-label", function () {
      prevIndex = $("main").css("z-index");
      $("main").css("z-index", "3");
      $("body").toggleClass("locked");
      $(".size-guide-section").show();
    });

    $(".size-guide-section .close").click(function () {
      closeSize();
    });

    $(".size-guide-section .size-selector span").click(function () {
      $(".size-selector span").removeClass("active");
      $(this).addClass("active");

      var type = $(this).data("type");
      $(".size-guide-section .size-image picture").removeClass("active");
      $(
        '.size-guide-section .size-image picture[data-type="' + type + '"]',
      ).addClass("active");
    });

    $("body.product .accordion summary").click(function () {
      animateDetails($(this));
    });

    $("body.product .customize .customize-title").click(function () {
      var parent = $(this).parent();
      parent.toggleClass("active");
      if (parent.hasClass("active")) {
        var width = parent.data("width");
        var height = parent.data("height");
        parent.css("width", width + "px");
        parent.css("height", height + "px");
        $(".bg").css("width", width + "px");
        $(".bg").css("height", height + "px");
      } else {
        $(".thread-color .swatch").removeClass("active");
        $("#customization_thread").val("");
        $("#customization_initials").val("");
        $("#initials").val("");

        var width = $("body.product .customize .customize-title").outerWidth(
          true,
        );
        var height = $("body.product .customize .customize-title").outerHeight(
          true,
        );
        parent.css("width", width + "px");
        parent.css("height", height + "px");
        $(".bg").css("width", width + "px");
        $(".bg").css("height", height + "px");
      }
    });

    $("#initials").bind("keypress keyup change", function () {
      $("#customization_initials").val($(this).val());
      if ($(this).val() != null && $("#initials").val() != "") {
        var first = $(".thread-color .swatch")[0];
        $(first).addClass("active");
        $("#customization_thread").val($(first).data("color-name"));
      } else {
        $(".thread-color .swatch").removeClass("active");
        $("#customization_thread").val("");
      }
    });

    $(".thread-color .swatch").click(function () {
      $(".thread-color .swatch").removeClass("active");

      $(this).addClass("active");
      $("#customization_thread").val($(this).data("color-name"));

      if ($("#initials").val() == null || $("#initials").val() == "") {
        $("#initials").focus();
      }
    });

    $("body.product .customize").data(
      "width",
      $("body.product .customize").width(),
    );
    $("body.product .customize").data(
      "height",
      $("body.product .customize").height(),
    );

    $("body.product .customize, .bg").css(
      "width",
      $("body.product .customize .customize-title").outerWidth(true) + "px",
    );
    $("body.product .customize, .bg").css(
      "height",
      $("body.product .customize .customize-title").outerHeight(true) + "px",
    );
    $("body.product .customize").removeClass("initial");

    // $(".accordion__title").html("More " + $(".accordion__title").html());

    checkSelected();
    checkMobile();
    variantSelection();
    toggleAddToCart();
    selectColor();
    showSoldOut();
    showSellingFast();
    if ($("#ProductGridContainer").length) {
      showSellingFastCollection();
    }
  });

  $(window).resize(function () {
    checkMobile();
  });

  function showSoldOut() {
    $(".size-wrap label.disabled").mouseover(function () {
      var colorIndex = $("#option-index").data("color-index");
      var sizeIndex = $("#option-index").data("size-index");
      var size = $(this).data("value-no-handle");
      var val = $('input[name="Colour"]:checked + label .swatch').data(
        "color-name",
      );

      if (!val)
        val = $('input[name="Color"]:checked + label .swatch').data(
          "color-name",
        );

      // console.log(size);
      // console.log(val);

      var variantData = JSON.parse(
        $('variant-radios [type="application/json"]').html(),
      );
      var variantAvailable = false;
      variantData.forEach((element) => {
        // console.log(element.options[colorIndex] + " " + val  + " , " + element.options[sizeIndex] + " " + size);
        if (
          element.options[colorIndex] == val &&
          element.options[sizeIndex] == size &&
          element.available
        ) {
          variantAvailable = true;
        }
      });

      if (!variantAvailable) {
        $(".main-product__tag .sold-out.badge").show();
      }
    });

    $(".size-wrap label.disabled").mouseleave(function () {
      $(".main-product__tag .sold-out.badge").hide();
    });
  }

  function showSellingFast() {
    $(".size-wrap label:not(.disabled)").mouseover(function () {
      var colorIndex = $("#option-index").data("color-index");
      var sizeIndex = $("#option-index").data("size-index");
      var size = $(this).data("value");
      var val = $('input[name="Colour"]:checked + label .swatch').data("color");

      if (!val)
        val = $('input[name="Color"]:checked + label .swatch').data("color");

      // console.log(size);
      // console.log(val);

      var sellingFast = false;
      $(".inventory").each((index, element) => {
        var tempColor = $(element).data("color");
        var tempSize = $(element).data("size");
        var tempQty = $(element).data("qty");
        // console.log(tempColor + ' ' + tempSize + ' ' + tempQty);
        if (
          tempColor == val &&
          tempSize == size &&
          tempQty <= window.sellingFast
        ) {
          if (tempQty == 1) {
            $(".main-product__tag .last-piece.badge").show();
          } else if (tempQty == 2) {
            $(".main-product__tag .last-two.badge").show();
          } else if (
            tempQty >= window.fewLeftMin &&
            tempQty <= window.fewLeft
          ) {
            $(".main-product__tag .few-pieces.badge").show();
          } else if (tempQty <= window.sellingFast) {
            $(".main-product__tag .selling-fast.badge").show();
          }
        }
      });
    });

    $(".size-wrap label:not(.disabled)").mouseleave(function () {
      $(".last-piece.badge").hide();
      $(".last-two.badge").hide();
      $(".few-pieces.badge").hide();
      $(".selling-fast.badge").hide();
    });
  }

  function showSellingFastCollection() {
    $(".color-size-variant.active").mouseover(function () {
      console.log("is this working?");
      var size = $(this).data("size");
      var card = $(this).closest(".card");
      var sizeInput = card.find('.card__badge input[data-size="' + size + '"]');
      var qty = sizeInput.data("qty");

      if (qty == 1) {
        var lastPieceBadge = card.find(".card__badge .last-piece.badge");
        lastPieceBadge.show();
        card.find(".card__badge span:not(.last-piece.badge)").hide();
      } else if (qty == 2) {
        var lastTwoBadge = card.find(".card__badge .last-two.badge");
        lastTwoBadge.show();
        card.find(".card__badge span:not(.last-two.badge)").hide();
      } else if (qty >= window.fewLeftMin && qty <= window.fewLeft) {
        var fewLeftBadge = card.find(".card__badge .few-left.badge");
        fewLeftBadge.show();
        card.find(".card__badge span:not(.few-left.badge)").hide();
      } else if (qty <= window.sellingFast) {
        var sellingFastBadge = card.find(".card__badge .selling-fast.badge");
        sellingFastBadge.show();
        card.find(".card__badge span:not(.selling-fast.badge)").hide();
      }
    });

    $(".color-size-variant.active").mouseleave(function () {
      var card = $(this).closest(".card");
      var lastPieceBadge = card.find(".last-piece.badge");
      lastPieceBadge.hide();

      var lastTwoBadge = card.find(".last-two.badge");
      lastTwoBadge.hide();

      var fewLeftBadge = card.find(".few-left.badge");
      fewLeftBadge.hide();

      var sellingFastBadge = card.find(".selling-fast.badge");
      sellingFastBadge.hide();

      card.find(".card__badge span:not(.badge.hover)").show();
    });
  }

  function selectColor() {
    $selectedColour = $('input:checked[type="radio"][name="Colour"]').val();
    $target = $(
      '.product-form__input.color .swatch[data-color-name="' +
        $selectedColour +
        '"]',
    );

    $target.click();
  }

  function closeSize(element) {
    $("main").css("z-index", prevIndex);
    $("body").toggleClass("locked");
    $(".size-guide-section").hide();
  }

  function animateDetails(summary) {
    // var title = summary.find(".accordion__title");
    // if (summary.attr("aria-expanded") == "true") {
    //   var height =
    //     summary.parent().find(".accordion__content").height() +
    //     summary.height();
    //   summary.css("transform", "translate3d(0, " + height + "px, 0)");
    //   title.html("Less " + title.data("title"));
    // } else {
    //   title.html("More " + title.data("title"));
    //   summary.css("transform", "");
    // }
  }

  function changeImages(color) {
    $(".product__media-list img").each((index, element) => {
      $(element).closest("li").removeClass("active is-active");
      $;
    });

    if ($(".thumbnail-slider .thumbnail-list__item").length > 0) {
      $(".thumbnail-slider .thumbnail-list__item").each((index, element) => {
        $(element).attr("hidden", true);
      });
    }
    var selector = '.product__media-list img[data-color="' + color + '"]';
    if ($('.product__media-list img[data-color="' + color + '"]').length == 0) {
      selector = ".product__media-list img";
    }
    // this is for stacked images layout
    $(selector).each((index, element) => {
      if (index == 0) {
        $(element).closest("li").addClass("is-active");
      }
      $(element).closest("li").addClass("active");
    });

    // dont forget the thumbnails
    if ($(".thumbnail-slider .thumbnail-list__item").length > 0) {
      $(".thumbnail-slider .thumbnail-list__item img").each(
        (index, element) => {
          const colorElement = $(element).attr("data-color");
          if (color == colorElement) {
            $(element).closest(".thumbnail-list__item").attr("hidden", false);
          }
          // console.log($(element).find("img").attr("data-color"));
          // if ($(element).find("img").attr("data-color") == color) {
          //   console.log($(element));
          //   $(element).attr("hidden", false);
          // }
        },
      );
    }
  }

  function checkMobile() {
    if (isMobile()) {
      // $(".product__accordion details").each((index, element) => {
      //   $(element).attr("open", "");

      //   var summary = $(element).find("summary");
      //   summary.attr("aria-expanded", "true");
      //   summary.css("opacity", "0");

      //   animateDetails(summary);
      // });
      // remove sticky if fastbundle exist
      var productFormWrapper = $(".product-form-wrapper");
      if (productFormWrapper.find("#rbr-container-element-true")) {
        productFormWrapper.css({
          position: "relative",
        });
      }
    } else {
      $(".product__accordion details").each((index, element) => {
        $(element).find("summary").css("opacity", "1");
      });
    }
  }

  function isMobile() {
    return $(window).width() < 767;
  }

  function checkSelected() {
    if ($("fieldset.product-form__input").length < 1) {
      return;
    }
    $("fieldset.product-form__input").each(function () {
      var selected = $(this).find("input:checked");

      if (selected.length < 1) {
        $(".product-form__submit").prop("disabled", true);
      }
    });
  }

  function variantSelection() {
    $(document).change("fieldset.product-form__input input", function (evt) {
      var target = $(evt.target);
      checkSelected();
    });

    $(
      ".product-form__input input[type=radio][name=Colour], .product-form__input input[type=radio][name=Color]",
    ).click(function () {
      var variantData = JSON.parse(
        $('variant-radios [type="application/json"]').html(),
      );
      var colorIndex = $("#option-index").data("color-index");
      var sizeIndex = $("#option-index").data("size-index");

      var val = $(this).val();
      // console.log(colorIndex);
      // console.log(sizeIndex);
      // console.log(variantData);
      // console.log(val);

      $(".product-form__input input[type=radio][name=Size]").each(
        (index, e) => {
          var size = $(e).val();
          var id = $(e).attr("id");

          var variantAvailable = false;
          variantData.forEach((element) => {
            if (
              element.options[colorIndex] == val &&
              element.options[sizeIndex] == size &&
              element.available
            ) {
              variantAvailable = true;
            }
          });

          if (!variantAvailable) {
            $("label[for=" + id + "]").addClass("disabled");
          } else {
            $("label[for=" + id + "]").removeClass("disabled");
          }
        },
      );
    });
  }

  function toggleAddToCart() {
    $(".product-form__buttons").click(function () {
      var button = $(this).find("button");
      if (button.hasClass("disabled") || button.attr("disabled")) {
        return;
      }
      $(this).addClass("added");
      setTimeout(function () {
        $(".product-form__buttons").removeClass("added");
      }, 1500);
    });
  }
})(jQuery);
